import { render, staticRenderFns } from "./full-page-dialog.component.vue?vue&type=template&id=71a871df&scoped=true"
import script from "./full-page-dialog.component.ts?vue&type=script&lang=ts&external"
export * from "./full-page-dialog.component.ts?vue&type=script&lang=ts&external"
import style0 from "./full-page-dialog.component.vue?vue&type=style&index=0&id=71a871df&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a871df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a871df')) {
      api.createRecord('71a871df', component.options)
    } else {
      api.reload('71a871df', component.options)
    }
    module.hot.accept("./full-page-dialog.component.vue?vue&type=template&id=71a871df&scoped=true", function () {
      api.rerender('71a871df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/FullPageDialog/full-page-dialog.component.vue"
export default component.exports